import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-page-filter',
  templateUrl: './page-filter.component.html',
  styleUrls: ['./page-filter.component.css']
})
export class PageFilterComponent implements OnInit {

  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  pageNumber!: number;
  @Output() pageFilter = new EventEmitter<any>();   

  constructor() { /* TODO document why this constructor is empty */ }  

  ngOnInit(): void {
    // TODO document why this method 'ngOnInit' is empty
  }

  goToPage() {
    this.pageFilter.emit(this.pageNumber); 
  }

  numberOnly(event: any, type?: string): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode === 101 || charCode === 69 || charCode === 46 || charCode === 43 || charCode === 45) {
      return false;
    }
    return true; 
  }

}
